<div class="widget-container">
  <ion-grid>
    <ion-row class="close-row">
      <ion-col (click)="close()" class="close-col">
        <img src="../../../assets/icon/cancel.svg" alt="">
      </ion-col>
    </ion-row>

    <div>
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            <label> {{ 'Project Access Request' | translate}} </label>
          </div>
          <div style="margin-top: 8px;"><label class="c-stepper__title">The projects you have requested access
              to</label>
          </div>
        </ion-col>
      </ion-row>
      <div style="margin-top: 3em;">
        <ion-card class="proTable">
          <div style="padding: 21px;">
            <ion-row>
              <ion-col class="texttitle"> {{ 'Project Id' | translate}}</ion-col>
              <ion-col class="texttitle"> {{ 'Project Name' | translate}}</ion-col>
              <ion-col class="texttitle"> {{ 'Region' | translate}}</ion-col>
              <ion-col class="texttitle"> {{ 'Approved By' | translate}}</ion-col>
              <ion-col class="texttitle"> {{ 'Requested On' | translate}}</ion-col>
              <ion-col class="texttitle"> {{ 'Request Status' | translate}}</ion-col>
            </ion-row>
            <ion-row style="height: 10px"></ion-row>
            <ion-row class="testBottom"></ion-row>
            <ion-row class="testBottom" *ngFor="let item of projectAccess">
              <ion-col class="textlabel">{{item.ProjectId}}</ion-col>
              <ion-col class="textlabel">{{item.ProjectName}}</ion-col>
              <ion-col class="textlabel">{{item.Region}}</ion-col>
              <ion-col class="textlabel">{{item.Approved}}</ion-col>
              <ion-col class="textlabel">{{item.Request}}</ion-col>
              <ion-col class="textlabel"><button class="status-button"
                  [ngStyle]="{'background-color':item.RequestStatus === 'Approved' ? '#73D6BC' : item.RequestStatus === 'Pending' ? '#D93F4B' : item.RequestStatus === 'blocked' ? '#f78686' :'#97B5FA'}">{{item.RequestStatus}}
                </button></ion-col>
            </ion-row>
          </div>
        </ion-card>
      </div>
    </div>
  </ion-grid>
</div>